<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <header class="d-md-flex justify-content-md-between">
                    <h5>Cupones de descuento para los abonados</h5>
                    <div class="row">
                        <ModalCreate
                            class="mr-3 mb-sm-1"
                            @creado="getVouchers()"    
                        />
                        <ModalImportDiscounts
                            @creado="getVouchers()"    
                        />
                    </div>
                </header>
                <hr>
                <b-card-text>
                    <b-row>
                        <b-col cols="3" class="mb-3">
                            <SearchComponent v-model="filters.search" @input="debouncedGetVouchers"/>
                        </b-col>
                        <b-col cols="12">
                            <b-table
                                :busy="loading"
                                show-empty 
                                :items="vouchers.data"
                                :fields="fields"
                                empty-text="No se han encontrado cupones"
                            >
                                <template #cell(opciones)="{ item }">
                                    <OpcionesDropdownComponent v-bind:options="[
                                        { type: 'action', action:() => showModal('edit-voucher-' + item.id), label: 'EDITAR'},
                                        { type: 'action', action:() => showModal('borrarCupon-' + item.id), label: 'BORRAR'},
                                    ]" v-on:open="onOpenOptions"
                                    />
                                    <ModalEdit
                                        :voucher_id="item.id" 
                                        @actualizar="getVouchers()"
                                        :show="activeModal"
                                    />
                                    <DeleteCuponModal :voucher="item" @close="closeModal" @actualizar="getVouchers()"></DeleteCuponModal>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <hr>
                        <div class="row justify-content-between">
                            <div class="col-md-6 col-sm-12">                               
                                 <ElementosPorPaginaComponent 
                                    v-model="filters.per_page"
                                    @input="changePerPage"
                                ></ElementosPorPaginaComponent>
                            </div>
                            <div class="col-md-6 col-sm-12" v-if="vouchers">
                                <PaginateComponent 
                                    :current_page="vouchers.meta.current_page" 
                                    :last_page="vouchers.meta.last_page"
                                    v-on:change_page="setPage"
                                />
                            </div>
                        </div>
                </b-card-text>
            </b-card>
        </b-col>
        <b-col cols="12">
            <b-card>
                <header>
                    <h5>Configuración de cupones por región</h5>
                </header>
                <hr>
                <b-card-text>
                    <b-row>
                        <b-col cols="12" v-for="(region, index) in regiones" :key="index">
                            <b-row class="p-2">
                                <b-col cols="3">
                                    <b>{{ region.name }}</b>
                                </b-col>
                                <b-col cols="7">
                                    <multiselect
                                        v-model="region.vouchers"
                                        placeholder="Descuentos"
                                        label="name"
                                        track-by="id"
                                        :options="vouchers.data"
                                        :multiple="true"
                                    ></multiselect>
                                </b-col>
                                <b-col cols="2">
                                    <b-button @click="asignarCodigos(region)">Guardar</b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ModalCreate from '@/components/backend/abonos/precios/vouchers/modals/ModalCreate.vue';
import ModalEdit from '@/components/backend/abonos/precios/vouchers/modals/ModalEdit.vue';
import ModalImportDiscounts from '@/components/backend/abonos/precios/vouchers/modals/ModalImportDiscounts.vue';
import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
import DeleteCuponModal from '../modals/DeleteCuponModal';
import SearchComponent from '@/components/backend/components/SearchComponent';

export default {
    data() {
        return {
            vouchers: { data: [], meta: { current_page: 1 } }, 
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                all: 1
            },
            fields: [
                {
                    key: 'name',
                    label: 'Nombre'
                },
                {
                    key: 'code',
                    label: 'Código'
                },
                {
                    key: 'discount_fixed',
                    label: 'Descuento en €'
                },
                {
                    key: 'discount_percent',
                    label: 'Descuento en %'
                },
                {
                    key: 'units',
                    label: 'Unidades'
                },
                { key: "opciones", label: "Opciones", class: 'text-center' }
            ],
            activeModal: null,
            regiones: null,
            openOptions: [],
            loading: false
        }
    },
    computed: {
        lista() {
            return this.$store.getters.getListaId;
        }
    },
    created() {
        this.getVouchers();
        this.getRegiones();
        this.debouncedGetVouchers = _.debounce(this.getVouchers, 500)
    },
    methods: {
        setPage(page) {
            this.filters.page = page;
            this.getVouchers();
        },
        getVouchers() {
            this.loading = true;

            const params = {
                filters : this.filters,
                lista_id: this.lista
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers'), params).then(res => {
                this.vouchers = res.data;
            }).finally(() => {
                this.loading = false;
            });
        },
        changePerPage(per_page) {
            this.filters.per_page = per_page;
            this.getVouchers();
        },
        showModal(modal) {
            this.activeModal = modal;
            this.$modal.show(modal);
        },
        closeModal(modal) {
            this.activeModal = null;
            this.$modal.hide(modal);
        },
        onOpenOptions(ref) {
            this.openOptions.push(ref);
        },
        getRegiones() {
            this.loading = true;

            const params = {
                lista_id: this.lista
            };

            this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.regiones.disponibles'), params).then(res => {
                this.regiones = res.data.data;
            }).finally(() => {
                this.loading = false;
            });
        },
        asignarCodigos(region) {
            region.filters = {};
            region.lista_id = this.lista
            region.region_id = region.id;

            this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.regiones.asignar.codigos'), region).then(res => {
                this.getRegiones();
            });
            
        }
    },
    components: {
        ModalCreate, ModalEdit, ElementosPorPaginaComponent, PaginateComponent, OpcionesDropdownComponent, DeleteCuponModal, ModalImportDiscounts, SearchComponent
    }
}
</script>